export default "__VITE_ASSET__D9XC_0H$__"